import React from 'react';
import { product, brand } from '../mock';
import { ChevronRight, ShieldCheck, Leaf, Award } from 'lucide-react';

export default function Hero({ onShopClick }) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute -top-20 -right-32 blob" />
      <div className="absolute -bottom-40 -left-20 blob" style={{ opacity: 0.5 }} />

      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 pt-10 sm:pt-16 pb-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="tag-dot" /> India’s First Triple Magnesium
            </div>
            <h1 className="font-grotesk mt-4 text-5xl sm:text-6xl md:text-7xl leading-[0.98] font-medium tracking-[-0.02em]">
              Own Your <span className="italic font-display font-normal text-teal">Strength</span>.
              <br />
              Sleep. Recover. Rise.
            </h1>
            <p className="mt-5 text-neutral-600 dark:text-neutral-300 text-lg max-w-lg leading-relaxed">
              Corevive <b>Magnesium TriMag™</b> — 320&nbsp;mg elemental magnesium in three highly-absorbable forms, boosted with Vitamin D3 & B12. One tablet a day. Real recovery.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <button onClick={onShopClick} className="pill-btn teal hover-lift">
                <span className="dot" /> Shop TriMag – ₹1,299 <ChevronRight size={14} />
              </button>
              <a href="#science" className="pill-btn light">
                <span className="dot" /> How it works
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-[13px] text-neutral-500">
              <span className="inline-flex items-center gap-2"><ShieldCheck size={16} className="text-teal" /> Third-party lab tested</span>
              <span className="inline-flex items-center gap-2"><Leaf size={16} className="text-teal" /> 100% Vegetarian</span>
              <span className="inline-flex items-center gap-2"><Award size={16} className="text-teal" /> GMP-certified</span>
            </div>
          </div>

          <div className="relative h-[520px] sm:h-[620px] flex items-center justify-center">
            <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[color:var(--cv-teal-soft)] via-white to-[color:var(--cv-teal-soft)] dark:from-neutral-900 dark:via-neutral-900 dark:to-neutral-950" />
            <div className="absolute inset-x-10 top-10 bottom-10 rounded-[28px] border border-white/40 dark:border-white/5" />
            <div className="relative w-[420px] h-[520px] product-crop-container">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover product-float product-crop drop-shadow-[0_35px_45px_rgba(17,138,148,0.25)]" />
            </div>
            <div className="absolute top-6 left-6 z-20 inline-flex items-center gap-2 bg-white/90 dark:bg-neutral-900/90 backdrop-blur px-3 py-1.5 rounded-full text-[10px] font-semibold tracking-[0.22em] uppercase shadow-sm">
              <span className="tag-dot" /> Just Launched
            </div>
            <div className="absolute bottom-6 right-6 z-20 bg-white/95 dark:bg-neutral-900/95 backdrop-blur rounded-2xl px-4 py-3 shadow-lg">
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">Elemental Mg</div>
              <div className="font-grotesk text-2xl font-semibold">320<span className="text-sm">mg</span></div>
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -left-2 sm:left-2 z-20 bg-white/95 dark:bg-neutral-900/95 backdrop-blur rounded-2xl px-4 py-3 shadow-lg">
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">Formula</div>
              <div className="font-grotesk text-base font-semibold">Triple Complex</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
